import { getRequest } from '../services/requestHandler';
import { HeadModelForDropdownDto } from '../models';

export const GetHeadModelsByManufacturerAndTypeForDropdown = async (headManufacturerId: number, headTypeId: number) => {
  const url = `head/getHeadModelsByManufacturerAndTypeForDropdown?manufacturerId=${headManufacturerId}&headTypeId=${headTypeId}&activeOnly=true`;
  const response = await getRequest<HeadModelForDropdownDto>('GetHeadModelsByManufacturerAndTypeForDropdown', url);
  return response;
};
